import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
} from '@angular/core';
import { FontType, FontWeight, TextSize } from '@freelancer/ui/text';

export const APPROXIMATE_COUNT_DEFAULT_STEPS: readonly number[] = [
  10,
  25,
  50,
  100,
];

@Component({
  selector: 'app-approximate-count',
  template: `
    <fl-text
      [fontType]="FontType.SPAN"
      [size]="TextSize.INHERIT"
      [weight]="FontWeight.INHERIT"
    >
      <ng-container *ngIf="value > 0; else zeroValue">
        <ng-container
          *ngIf="activeStep; else lessThanFirstStep"
          i18n="More than the current step label"
        >
          more than {{ activeStep }}
        </ng-container>
        <ng-template #lessThanFirstStep>
          <ng-container i18n="Less than the first step label">
            less than {{ steps[0] }}
          </ng-container>
        </ng-template>
      </ng-container>
      <ng-template #zeroValue>{{ value }}</ng-template>
    </fl-text>
  `,
  styleUrls: ['./approximate-count.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApproximateCountComponent implements OnChanges {
  FontType = FontType;
  FontWeight = FontWeight;
  TextSize = TextSize;

  activeStep?: number;

  @Input() steps = APPROXIMATE_COUNT_DEFAULT_STEPS;
  @Input() value = 0;

  ngOnChanges() {
    this.activeStep = [...this.steps].reverse().find(s => s <= this.value);
  }
}
